import { useEffect, useRef } from "react";

import { ReservationThreadData } from "../types/reservation";

export const useScrollToEnd = (threads: ReservationThreadData[]) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [threads]);

  return messagesEndRef;
};
